<div class="subcomponent-inner-wrap" xmlns="http://www.w3.org/1999/html">
	<mat-card style="font-size: 14px" class="acies-card">
		<mat-card-content>
			<router-outlet></router-outlet>
		</mat-card-content>
	</mat-card>
</div>
